import { type PropsWithChildren } from 'react'
import { type i18n as I18nInstance } from 'i18next'
import { I18nextProvider } from 'react-i18next'
import { type EmotionCache } from '@emotion/react'
import MuiProvider from 'components/MuiProvider/MuiProvider'

// The provider tree wrapped around the app by BOTH entry.server and entry.client.
// The server-rendered and client-hydrated trees must stay identical for React to
// hydrate cleanly, so it is composed once, here.
export function EntryProviders({
  i18n,
  emotionCache,
  children,
}: PropsWithChildren<{ i18n: I18nInstance; emotionCache: EmotionCache }>) {
  return (
    <I18nextProvider i18n={i18n}>
      <MuiProvider value={emotionCache}>{children}</MuiProvider>
    </I18nextProvider>
  )
}
